/**
 * Sorting order enum
 */
export enum SortOrderEnum {
    asc = 'asc',
    desc = 'desc',
}
